import React, { useEffect } from 'react';
import { useSearchkit } from '@searchkit/client';

const FacetList = (components = []) => {
  const FacetsMapper = [
    ...components,
  ].reduce((sum, component) => {
    sum[component.DISPLAY] = component;
    return sum;
  }, {});

  return ({ data, loading }) => {
    return (
      <div className="SearchFacets">
        {
          data && data.facets && data.facets.map((facet) => {
            const Facet = FacetsMapper[facet.display];
            if (!Facet) {
              throw new Error(`${facet.display} not available`);
            }
            return (
              <Facet key={facet.identifier} facet={facet} loading={loading} />
            );
          })
        }
      </div>
    );
  };
};

export const SearchFacets = ({ data, loading, facets, onChange }) => {
  const api = useSearchkit();
  const Facets = FacetList(facets);

  useEffect(() => {
    if (onChange) {
      const filterArray = [];
      api.getFilters().forEach((filter) => {
        filterArray.push({ identifier: filter.identifier, value: filter.value });
      });
      onChange(data.results.facets, filterArray);
    }
  });

  if (!data) {
    return null;
  }

  return (
    <div className="SearchFacets">
      <Facets data={data.results} loading={loading} />
    </div>
  );
};

SearchFacets.defaultProps = {
  data: null,
  loading: false,
  facets: [],
};
